import { Component, inject, OnInit, signal } from '@angular/core';
import { DrugListComponent } from '@beautyapp/shared';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { NzFormDirective } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { InputModule } from '@beautyapp/form';
import { ErxService } from '@beautyapp/core';
import { TextareaComponent } from '../../../../../form/src/lib/textarea/textarea.component';

@UntilDestroy()
@Component({
  selector: 'beautyapp-add-erx',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    NzFormDirective,
    NzGridModule,
    NzModalModule,
    NzButtonModule,
    NzRadioModule,
    NzCheckboxModule,
    TextareaComponent,
    InputModule
],
  templateUrl: './add-erx.component.html',
  styleUrl: './add-erx.component.scss'
})
export class AddErxComponent implements OnInit {
  data = inject(NZ_MODAL_DATA);
  erxService = inject(ErxService);
  modalService = inject(NzModalService);
  modalRef = inject(NzModalRef);
  translateService = inject(TranslateService);

  form: FormGroup = new FormGroup({
    prodCount: new FormControl(null, [Validators.required]),
    duration: new FormControl(null, [Validators.required]),
    ds: new FormControl(null, [Validators.required]),
    dosagePriv: new FormControl(false),
    isCopy: new FormControl(false),
    isGeneric: new FormControl(null, [Validators.required]),
    productId: new FormControl(null),
    productName: new FormControl(null)
  });

  selectedProduct = signal<any | null>(null);
  prescription = signal<any | null>(null);
  isGenericDisabled = signal<boolean>(false);

  ngOnInit() {
    if (this.data.prescription) {
      this.prescription.set(this.data.prescription);
      this.selectedProduct.set(this.data.prescription.product);
      this.form.patchValue({
        prodCount: this.data.prescription.prodCount,
        duration: this.data.prescription.duration,
        ds: this.data.prescription.ds,
        dosagePriv: this.data.prescription.dosagePriv,
        isCopy: this.data.prescription.isCopy,
        isGeneric: this.data.prescription.isGeneric,
        isTradeable: this.data.prescription.isTradeable,
        productId: this.data.prescription.productId,
        productName: this.data.prescription.productName
      });
    }

  }

  chooseDrug() {
    this.modalService.create({
      nzOkDisabled: true,
      nzCancelText: this.translateService.instant('general.close'),
      nzTitle: this.translateService.instant('ERX.chooseProductTitle'),
      nzContent: DrugListComponent,
      nzWidth: '60%'
    }).afterClose.pipe(
      untilDestroyed(this)
    ).subscribe(res => {
      console.log(res);
      if (res) {
        this.selectedProduct.set(res);
        this.form.patchValue({
          productId: res.id,
          productName: res.geoTradeName,
          isGeneric: !!res.productGeneric,
          isTradeable: !res.productGeneric
        });
      }
    });
  }

  submit() {
    console.log(this.form);
    console.log(this.data);
    console.log(this.form.invalid);
    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    // Check if in template mode
    if (this.data.isTemplateMode) {
      // In template mode, just return the form data without API call
      const prescriptionData = {
        ...this.form.value,
        product: this.selectedProduct()
      };
      this.modalRef.close(prescriptionData);
      return;
    }

    // Normal mode - make API calls
    if (this.data.prescription?.id) {
      this.erxService.update(this.data.prescription.id, {
        ...this.form.value,
        id: this.data.prescription.id,
        ehrId: this.data.ehrId,
        userId: this.data.userId,
        employeeId: this.data.employeeId
      }).pipe()
        .subscribe(res => {
          this.modalRef.triggerOk();
        });
    } else {
      this.erxService.create({
        ...this.form.value,
        ehrId: this.data.ehrId,
        userId: this.data.userId,
        employeeId: this.data.employeeId
      }).pipe()
        .subscribe(res => {
          this.modalRef.triggerOk();
        });
    }
  }
}
